var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookies from 'js-cookie';
import { API, AtoZQueryClient, Endpoints, Metric, Trace, Log, } from '@amzn/showtime';
import AsyncStorage from '@react-native-async-storage/async-storage';
import TENANT_ID from '../TenantId';
const logger = Log(TENANT_ID);
export const ATOZ_AUTH_TOKEN_COOKIE_NAME = 'atoz-oauth-token';
export const ATOZ_AUTH_TOKEN_INTEG_DOMAIN = '.integ.amazon.com';
const NO_OP = () => { };
export function getAccessToken(devAuthToken) {
    return __awaiter(this, void 0, void 0, function* () {
        // ESSP sets the http-only header, so Cookies.get will return undefined in production.
        // Instead, the cookie is included automatically by the Apollo client in Showtime's api.ts
        let token = Cookies.get(ATOZ_AUTH_TOKEN_COOKIE_NAME);
        if (__DEV__ && !token && devAuthToken) {
            token = devAuthToken;
            console.log('Setting devAuthToken');
            const options = {
                domain: ATOZ_AUTH_TOKEN_INTEG_DOMAIN,
                secure: true,
            };
            Cookies.set(ATOZ_AUTH_TOKEN_COOKIE_NAME, token, options);
        }
        return token || null;
    });
}
export function refreshCookie(devAuthToken) {
    return __awaiter(this, void 0, void 0, function* () {
        yield getAccessToken(devAuthToken);
        return true;
    });
}
export function apiConfig({ devAuthToken, employeeId }) {
    return {
        baseUrl: Endpoints.ATOZ_API_GATEWAY,
        getAccessToken: () => getAccessToken(devAuthToken),
        refreshCookie: () => refreshCookie(devAuthToken),
        storageProvider: AsyncStorage,
        employeeId,
        shouldPurgeCache: false,
        // On native, these hooks are used to start and stop cache refresh polling. By design,
        // cache refresh polling doesn't happen on web. So it's fine to no-op these hooks on web.
        onAppForeground: NO_OP,
        onAppBackground: NO_OP,
    };
}
export default function bootstrapAPI(props) {
    return __awaiter(this, void 0, void 0, function* () {
        const trace = Trace('BootstrapAPI', TENANT_ID);
        const config = apiConfig(props);
        try {
            yield AtoZQueryClient.configure();
            yield API.configure(config);
            trace.log();
        }
        catch (err) {
            logger.error('APIBootstrappingError', { error: err });
            Metric('APIBootstrappingError', TENANT_ID).put();
        }
    });
}
//# sourceMappingURL=APIBootstrapping.js.map